/* ==========================================================================
   OSERE — Bucle de vídeo del hero

   Arranca el vídeo de fondo SOLO cuando procede, y nunca antes de que la
   página haya terminado de cargar.

   Por qué no basta con `autoplay` en el marcado:

   1. EL LCP. La imagen del hero es el Largest Contentful Paint. Un vídeo con
      autoplay empieza a descargar en paralelo y le roba ancho de banda justo
      en el momento que se mide. Con `preload="none"` en el HTML y el play
      diferido desde aquí, el vídeo no existe hasta que la foto ya está.

   2. MOVIMIENTO REDUCIDO. `prefers-reduced-motion: reduce` no es una
      preferencia estética: hay gente a la que el movimiento de fondo le
      produce mareo. Con esa preferencia activa el bucle no arranca nunca y se
      queda la fotografía.

   3. DATOS AJENOS. `connection.saveData` significa que la persona ha pedido
      explícitamente ahorrar datos, y `effectiveType` 2g/3g que está en una red
      lenta. En Colombia, con 70–80% de tráfico móvil, descargar un bucle
      decorativo ahí es cobrarle a alguien un capricho nuestro.

   4. PESTAÑA OCULTA. Un vídeo reproduciéndose en una pestaña que nadie mira
      gasta batería. Se pausa y se reanuda con visibilitychange.

   Y una más, específica de Dawn: `window.pauseAllMedia()` —que Dawn llama al
   abrir cualquier modal— pausa TODOS los vídeos de la página, incluido este.
   Al cerrar el modal nadie lo reanuda, así que el fondo se quedaba congelado.
   Aquí se observa el atributo `open` del modal y se devuelve a su sitio.
   ========================================================================== */

(function () {
  'use strict';

  var video = document.querySelector('[data-os-hero-video]');
  if (!video) return;

  var ESCRITORIO = 750;

  function permitido() {
    // Movimiento reducido: no se discute.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;

    // El cliente puede apagar el bucle en móvil desde los ajustes.
    // matchMedia y no window.innerWidth: es la MISMA fuente que usa el CSS, así
    // que no pueden desincronizarse, y no se cae con un innerWidth de 0 —que es
    // lo que devuelve un panel de navegador sin dimensiones.
    if (
      video.hasAttribute('data-solo-escritorio') &&
      !window.matchMedia('(min-width: ' + ESCRITORIO + 'px)').matches
    ) {
      return false;
    }

    // Ahorro de datos y redes lentas.
    var con = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (con) {
      if (con.saveData) return false;
      if (/^(slow-)?2g$/.test(con.effectiveType) || con.effectiveType === '3g') return false;
    }

    return true;
  }

  function encender() {
    if (!permitido()) return;

    // preload="none" en el HTML: aquí se pide la carga explícitamente.
    video.preload = 'auto';
    video.muted = true; // iOS exige que esté puesto en el momento del play()

    var p = video.play();
    if (p && typeof p.catch === 'function') {
      // Si el navegador bloquea el autoplay no pasa nada: se queda la foto.
      // No se insiste ni se pide permiso — el vídeo es decoración.
      p.catch(function () {
        video.removeAttribute('data-os-activo');
      });
    }
  }

  // La clase la pone el propio vídeo cuando de verdad está pintando fotogramas,
  // no cuando se le pide play(). Así no hay fundido a un vídeo que no arrancó.
  video.addEventListener('playing', function () {
    video.setAttribute('data-os-activo', '');
  });

  /* ---- Arranque, después de la carga ------------------------------------ */

  function alRatoDeCargar() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(encender, { timeout: 2000 });
    } else {
      setTimeout(encender, 600);
    }
  }

  if (document.readyState === 'complete') alRatoDeCargar();
  else window.addEventListener('load', alRatoDeCargar, { once: true });

  /* ---- Pestaña oculta ---------------------------------------------------- */

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      video.pause();
    } else if (video.hasAttribute('data-os-activo')) {
      video.play().catch(function () {});
    }
  });

  /* ---- Reanudar al cerrar el modal --------------------------------------- */

  var modal = document.querySelector('modal-dialog[id^="OsHeroVideo-"]');
  if (modal && 'MutationObserver' in window) {
    new MutationObserver(function () {
      if (modal.hasAttribute('open')) {
        /* AL ABRIR: inyectar el vídeo.
           DeferredMedia de Dawn se dispara sola al pulsar un botón-póster
           interno, y aquí no hay ninguno: el clic ya lo dio el botón de play
           del hero. Sin esto el modal abría vacío — verificado midiendo:
           `loaded=false` y cero <video> en el DOM. */
        var deferred = modal.querySelector('deferred-media');
        if (deferred && !deferred.getAttribute('loaded')) deferred.loadContent(true);
        return;
      }

      /* AL CERRAR: devolver el bucle a su sitio.
         ModalDialog.hide() llama a pauseAllMedia(), que pausa TODOS los vídeos
         de la página incluido el fondo, y nadie lo reanuda. */
      if (video.hasAttribute('data-os-activo')) video.play().catch(function () {});
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
  }

  /* ---- Si cambian las condiciones ---------------------------------------- */

  window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', function (e) {
    if (e.matches) {
      video.pause();
      video.removeAttribute('data-os-activo');
    } else {
      encender();
    }
  });
})();
